import { WeddingInfoType } from "./WeddingInfo";

export const SampleWeddingInfo: WeddingInfoType = {
  common: {
    groomName: "박영철",
    brideName: "이옥순",
    groomShortName: "영철",
    brideShortName: "옥순",
    addressInfo: {
      name: "강남 더 채플앳 청담",
      lat: 37.522354,
      lon: 127.038924,
      address: "서울특별시 강남구 선릉로 757",
      naverAddress:
        "https://map.naver.com/p/search/%EB%8D%94%EC%B1%84%ED%94%8C%EC%95%B3%EC%B2%AD%EB%8B%B4/place/34120522?placePath=?entry=pll&from=nx&fromNxList=true&searchType=place&c=15.00,0,0,0,dh",
    },
    weddingDateKR: "2025월 05월 10일",
    weddingDate: "2025-05-10",
    groomAccountInfos: [
      {
        name: "박영철",
        bankName: "토스뱅크",
        bankImage: `${process.env.PUBLIC_URL}/toss.jpeg`,
        accountNumber: "123456-78-90123",
        isGroom: true,
        familyName: "",
      },
    ],
    brideAccountInfos: [
      {
        name: "이옥순",
        bankName: "카카오뱅크",
        bankImage: `${process.env.PUBLIC_URL}/kakaobank.png`,
        accountNumber: "987654-32-10987",
        isGroom: false,
        familyName: "",
      },
    ],
    accountInfos: [
      {
        name: "박영철",
        bankName: "토스뱅크",
        bankImage: `${process.env.PUBLIC_URL}/toss.jpeg`,
        accountNumber: "123456-78-90123",
        isGroom: true,
        familyName: "",
      },
      {
        name: "이옥순",
        bankName: "카카오뱅크",
        bankImage: `${process.env.PUBLIC_URL}/kakaobank.png`,
        accountNumber: "987654-32-10987",
        isGroom: false,
        familyName: "",
      },
    ],
    parentBGM: null,
    netflixBGM: null,
    spotifyBGM: null,
    instagramBGM: null,
  },
  /* Parent */
  parent: {
    startPhrase: "영철 그리고 옥순",
    shortPhrase: "결혼합니다!",
    mainImage: `${process.env.PUBLIC_URL}/samples/sample-couple-1.jpg`,
    weddingMessage: `바쁘신 가운데 두 사람의 앞날을 두 사람이 사랑으로 만나
  진실과 이해로써 하나를 이루려 합니다.
  
  이 두 사람을 지성으로 아끼고 돌봐주신
  여러 어른과 친지를 모시고 서약을 맺고자 하오니
  
  가까이에서 축복해 주시면 고맙겠습니다.`,
    groomFatherName: "박춘식",
    groomMotherName: "최영자",
    groomFamilyTitle: "장남",
    brideFatherName: "이춘삼",
    brideMotherName: "김미자",
    brideFamilyTitle: "장녀",
    photoGalleryPhrase: "추억을 함께 나눠요",
    photoGalleryImages: [
      `${process.env.PUBLIC_URL}/samples/sample-couple-6.jpg`,
      `${process.env.PUBLIC_URL}/samples/sample-couple-2.jpg`,
      `${process.env.PUBLIC_URL}/samples/sample-couple-3.jpg`,
      `${process.env.PUBLIC_URL}/samples/sample-couple-4.jpg`,
      `${process.env.PUBLIC_URL}/samples/sample-couple-5.jpg`,
      `${process.env.PUBLIC_URL}/samples/sample-couple-1.jpg`,
    ],
    poetry: `
    나의 여름이 모든 색을 잃고 
    흑백이 되어도 좋습니다 

    내가 세상의 꽃들과 들풀 
    숲의 색을 모두 훔쳐올테니 

    전부 그대의 것 하십시오
    그러니 그대는 나의 여름이 되세요`,
    endImage: `${process.env.PUBLIC_URL}/samples/sample-couple-2.jpg`,
  },
  /* Instagram */
  instagram: {
    storyImages: [
      `${process.env.PUBLIC_URL}/samples/sample-couple-1.jpg`,
      `${process.env.PUBLIC_URL}/samples/sample-couple-2.jpg`,
      `${process.env.PUBLIC_URL}/samples/sample-couple-3.jpg`,
      `${process.env.PUBLIC_URL}/samples/sample-couple-4.jpg`,
      `${process.env.PUBLIC_URL}/samples/sample-couple-5.jpg`,
      `${process.env.PUBLIC_URL}/samples/sample-couple-6.jpg`,
    ],
    postInfos: [
      {
        profileImage: `${process.env.PUBLIC_URL}/samples/sample-couple-6.jpg`,
        name: "영철 ❤️ 옥순",
        postImages: [
          `${process.env.PUBLIC_URL}/samples/sample-couple-1.jpg`,
          `${process.env.PUBLIC_URL}/samples/sample-couple-2.jpg`,
          `${process.env.PUBLIC_URL}/samples/sample-couple-3.jpg`,
          `${process.env.PUBLIC_URL}/samples/sample-couple-4.jpg`,
          `${process.env.PUBLIC_URL}/samples/sample-couple-5.jpg`,
          `${process.env.PUBLIC_URL}/samples/sample-couple-6.jpg`,
        ],
        title: "우리 결혼해요! 🤵🏻👰🏻",
        caption: "모두 축하해주셔서 감사합니다.",
      },
      {
        profileImage: `${process.env.PUBLIC_URL}/samples/sample-couple-6.jpg`,
        name: "영철 ❤️ 옥순",
        postImages: [
          `${process.env.PUBLIC_URL}/samples/sample-couple-4.jpg`,
          `${process.env.PUBLIC_URL}/samples/sample-couple-5.jpg`,
          `${process.env.PUBLIC_URL}/samples/sample-couple-6.jpg`,
          `${process.env.PUBLIC_URL}/samples/sample-couple-1.jpg`,
          `${process.env.PUBLIC_URL}/samples/sample-couple-2.jpg`,
          `${process.env.PUBLIC_URL}/samples/sample-couple-3.jpg`,
        ],
        title: "귀한 발걸음 해주셔서 감사드립니다. 🙇🏻🙇🏻‍♀️",
        caption: "모두 축하해주셔서 감사합니다.",
      },
    ],
    gridInfo: {
      profileImage: `${process.env.PUBLIC_URL}/samples/sample-couple-9.jpg`,
      name: "Our Memories",
      startDay: "2020-01-01",
      images: [
        `${process.env.PUBLIC_URL}/samples/sample-couple-1.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-2.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-3.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-4.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-5.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-6.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-7.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-8.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-9.jpg`,
      ],
    },
  },
  /* Spotify */
  spotify: {
    albumTitle: "영철이와 옥순이의 행복 리스트",
    albums: [
      {
        mainImage: `${process.env.PUBLIC_URL}/samples/sample-couple-1.jpg`,
        title: "바다에서 함께",
        caption: "영철이랑 옥순이",
        topRightCaption: "Love",
      },
      {
        mainImage: `${process.env.PUBLIC_URL}/samples/sample-couple-2.jpg`,
        title: "갈대밭에서",
        caption: "풍경을 바라보며",
        topRightCaption: "Love",
      },
      {
        mainImage: `${process.env.PUBLIC_URL}/samples/sample-couple-3.jpg`,
        title: "노을과 함께",
        caption: "아름다운 풍경",
        topRightCaption: "Love",
      },
      {
        mainImage: `${process.env.PUBLIC_URL}/samples/sample-couple-4.jpg`,
        title: "영원한 사랑",
        caption: "행복",
        topRightCaption: "Love",
      },
      {
        mainImage: `${process.env.PUBLIC_URL}/samples/sample-couple-5.jpg`,
        title: "볼 맞대고",
        caption: "친구처럼",
        topRightCaption: "Love",
      },
      {
        mainImage: `${process.env.PUBLIC_URL}/samples/sample-couple-6.jpg`,
        title: "노을 빛",
        caption: "황홀한 풍경",
        topRightCaption: "Love",
      },
    ],
    lyricTitle: "전하고 싶은 말",
    lyrics: [
      {
        message: `인생 가장 빛나는 날,

          소중한 분들을 모시고 기쁨을 나누면 좋겠지만
          혹 참석이 어려우시더라도 괜찮습니다.

          멀리서 축하해주신 분들과 어려운 발걸음
          해주신 분들 모두 마음에 새기고 항상 행복하게 살겠습니다.`,
        hightlightLines: [0],
        color: "bg-red-500/80",
      },
      {
        message: `이 두 사람을 지성으로 아끼고 돌봐주신
          여러 어른과 친지를 모시고 서약을 맺고자 하오니

          바쁘신 가운데 두 사람의 앞날을
          가까이에서 축복해 주시면 고맙겠습니다.

          감사합니다.`,
        hightlightLines: [3],
        color: "bg-spotify/80",
      },
      {
        message: `박영철 ♥ 이옥순

            고독한 마라톤인 줄로만 알았습니다
            재촉하지 않고 더 오래 걷자고
            
       서로의 다리에 결혼이라는 끝을 묶고
      달리기로 했습니다.

            황홀하게 기억하겠습니다. 
            출발선에 선 이 순간을`,
        hightlightLines: [0, 5, 6],
        color: "bg-yellow-500/80",
      },
    ],
    player: {
      sectionTitle: "우리들의 이야기",
      videoURL: `${process.env.PUBLIC_URL}/samples/sample-video.mp4`,
      title: "우리 결혼해요! (feat. 축하해주세요)",
      caption: "영철 ❤️ 옥순",
    },
    list: {
      sectionTitle: "인기 급상승 추억 리스트",
      images: [
        `${process.env.PUBLIC_URL}/samples/sample-couple-1.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-2.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-3.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-4.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-5.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-6.jpg`,
      ],
      titles: [
        "바다에서 함께",
        "갈대밭에서",
        "노을과 함께",
        "영원한 사랑",
        "볼 맞대고",
        "노을 빛",
      ],
      captions: [
        "영철이랑 옥순이",
        "풍경을 바라보며",
        "아름다운 풍경",
        "행복",
        "친구처럼",
        "황홀한 풍경",
      ],
    },
    artist: {
      sectionTitle: "여러 장소 리스트",
      images: [
        `${process.env.PUBLIC_URL}/samples/sample-couple-4.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-5.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-6.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-1.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-2.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-3.jpg`,
      ],
      titles: [
        "영원한 사랑",
        "볼 맞대고",
        "노을 빛",
        "바다에서 함께",
        "갈대밭에서",
        "노을과 함께",
      ],
      captions: [
        "행복",
        "친구처럼",
        "황홀한 풍경",
        "영철이랑 옥순이",
        "풍경을 바라보며",
        "아름다운 풍경",
      ],
    },
  },
  netflix: {
    posterInfo: {
      image: `${process.env.PUBLIC_URL}/samples/sample-couple-1.jpg`,
      title: " 우리들의 결혼 이야기",
      caption: "2025년 5월 10일 최초 공개",
    },
    top10Info: {
      sectionTitle: "우리들의 TOP 10 시리즈",
      images: [
        `${process.env.PUBLIC_URL}/samples/sample-couple-1.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-2.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-3.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-4.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-5.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-6.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-7.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-8.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-9.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-10.jpg`,
      ],
    },
    newHotInfo: {
      videoURL: `${process.env.PUBLIC_URL}/samples/sample-video.mp4`,
      title: "우리들의 결혼 이야기",
      caption: "5월 10일 새로운 에피소드 공개",
      message: `덥고 먼 길 힘드시겠지만 귀한 걸음 하시어 새롭게 시작될 저희의
              계절을 축복해 주시면 저희에겐 더없는 기쁨이 될 것 같습니다.`,
    },
    heartInfo: {
      sectionTitle: "우리가 찜한 리스트",
      titles: ["볼 맞대고", "노을", "행복", "웃음", "파리", "꽃"],
      images: [
        `${process.env.PUBLIC_URL}/samples/sample-couple-5.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-6.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-7.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-8.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-9.jpg`,
        `${process.env.PUBLIC_URL}/samples/sample-couple-10.jpg`,
      ],
      percents: [30, 20, 50, 80, 70, 10],
    },
    accountInfo: [
      {
        name: "박영철",
        bankName: "토스뱅크",
        bankImage: `${process.env.PUBLIC_URL}/toss.jpeg`,
        accountNumber: "123456-78-90123",
        isGroom: true,
        familyName: "",
      },
      {
        name: "이옥순",
        bankName: "카카오뱅크",
        bankImage: `${process.env.PUBLIC_URL}/kakaobank.png`,
        accountNumber: "987654-32-10987",
        isGroom: false,
        familyName: "",
      },
    ],
  },
};
